module.exports = __webpack_public_path__ + "img/rita.ace0dfa4.jpg";